import {React, useEffect, useState} from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { imageURl, isEuro, SpeakUrl } from "../../libs/env";
import { Row } from "reactstrap";
import IntroductionModal from "../../components/setup_modals/IntroductionModal";
import SystemModal from "../../components/setup_modals/SystemModal";
import TipsModal from "../../components/setup_modals/TipsModal";
import ConfirmSetupModal from "../../components/setup_modals/ConfirmSetupModal";
import {ModalProgressBar} from "../../components/setup_modals/ModalProgressBar";
const check_status = [];
const SystemRequirementsModal = ({ data,isOpen, toggle, setAssessmentStarted }) => {
  const [CurrentView, setCurrentView] = useState(1);

  useEffect(()=>{
    if(window.location.pathname.includes(SpeakUrl))
    {
      setCurrentView(1);
    }
  },[isOpen])
  const ClickOnPart = (props) => {
    setCurrentView(props);
    check_status.push(props-1);
    console.log(check_status)
  };
  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      toggle={toggle}
      className="modal-dialog-centered"
      backdrop={data.status=== "In progress"? "":"static"}
    >
      <ModalBody className="px-0 py-3" data-tc="system-requirement-modal">
        <Row>
          <div className="text-center px-4">
          {window.location.origin.includes(isEuro) ? (
              <button
                onClick={() => {
                  setAssessmentStarted(true);
                  toggle();
                }}
                className="btn p-0 float-end me-2"
              >
                <img
                  src={`${imageURl}/close.png`}
                  width="17px"
                  alt="Cross img"
                />
              </button>
            ) : (
              <button onClick={toggle} className="btn p-0 float-end me-2">
                <img
                  src={`${imageURl}/close.png`}
                  width="17px"
                  alt="Cross img"
                />
              </button>
            )}
          </div>
        </Row>
        <Row>
          <div className="text-center px-5 smb-4">
            <ModalProgressBar  CurrentView={CurrentView} check_status={check_status} setCurrentView={setCurrentView} />
          </div>
        </Row>
        { CurrentView &&  CurrentView === 1 ? 
          (
            <IntroductionModal  onClick={(props) => ClickOnPart(props)} toggle={toggle}  setAssessmentStarted={setAssessmentStarted} />
          ):  CurrentView === 2 ? 
          (
            <SystemModal data={data}  onClick={(props) => ClickOnPart(props)} toggle={toggle}  setAssessmentStarted={setAssessmentStarted} />
          ):  CurrentView === 3 ? 
          (
            <TipsModal  onClick={(props) => ClickOnPart(props)} toggle={toggle}  setAssessmentStarted={setAssessmentStarted} />
          ) : 
          (
            <ConfirmSetupModal isOpen={isOpen} toggle={toggle}  setAssessmentStarted={setAssessmentStarted} />
          )
        }
      </ModalBody>
    </Modal>
  );
};

SystemRequirementsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

SystemRequirementsModal.defaultProps = { isOpen: false };

export default SystemRequirementsModal;
